import MarketQuoteList from './MarketQuoteList';

export default MarketQuoteList;
